var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card-item',{staticClass:"user-visits",attrs:{"card":"item_user_visits","tabs":_vm.tabs,"activeTab":_vm.activeTab,"id":_vm.id,"user":_vm.user}})
}
var staticRenderFns = []

export { render, staticRenderFns }